import React, { useState, useCallback, useEffect } from "react";
import {
  CheckboxGroup,
  CheckboxItem,
  FormSection,
  Required,
  WarningBox,
} from "../../styles";
import { setWarning, unsetWarning } from "../../../utils";
import { InputGroup } from "../../../register/styles";

const confirmInput = (target) => {
  if (target.value.trim()) {
    unsetWarning(target);
    return true;
  } else {
    setWarning(target);
    return false;
  }
};

const confirmEmail = (target) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(target.value)) {
    unsetWarning(target);
    return true;
  } else {
    setWarning(target);
    return false;
  }
};

const RemoveDataForm = ({layout, formData, setFormData, text, setText}) => {
  const handleInputChange = useCallback((e) => {
    const target = e.target;
    let value = target.value;
    if(target.type === "checkbox") {
      value = target.checked;
    }
    setFormData((prev) => ({
      ...prev,
      [target.name]: value,
    }));
  }, [setFormData]);

  return (
    <FormSection layout={layout}>
      <h3>{text?.dadosIdentificacao}</h3>
      <InputGroup className="input_group">
        <label className="midsize">
          <p>
            {text?.nomeCompleto} <Required>*</Required>
          </p>
          <input
            required
            type="text"
            name="fullName"
            value={formData?.fullName}
            onChange={handleInputChange}
            onBlur={(e) => confirmInput(e.target)}
            placeholder={text?.placeholderNome}
          />
        </label>

        <label className="midsize">
          <p>
            {text?.emailCadastrado} <Required>*</Required>
          </p>
          <input
            required
            type="email"
            name="email"
            value={formData?.email}
            onChange={handleInputChange}
            onBlur={(e) => confirmEmail(e.target)}
            placeholder={text?.placeholderEmail}
          />
        </label>

        <label className="midsize">
          <p>
            {text?.solicitacao}
          </p>
          <textarea
            name="request"
            value={formData?.reason}
            onChange={handleInputChange}
            onBlur={(e) => confirmInput(e.target)}
            placeholder={text?.placeholderMotivo}
            rows={4}
          />
        </label>
      </InputGroup>

      <WarningBox>
        <strong>{text?.atencao}</strong> {text?.avisoIrreversivel}
      </WarningBox>

      <CheckboxGroup>
        <CheckboxItem>
          <input
            required
            type="checkbox"
            id="isHolder"
            name="isHolder"
            onChange={handleInputChange}
          />
          <label htmlFor="isHolder">{text?.confirmacao1}</label>
        </CheckboxItem>

        <CheckboxItem>
          <input
           required
            type="checkbox"
            id="isAware"
            name="isAware"
            onChange={handleInputChange}
          />
          <label htmlFor="isAware">{text?.confirmacao2}</label>
        </CheckboxItem>

        <CheckboxItem>
          <input
            required
            type="checkbox"
            id="understandLegal"
            name="understandLegal"
            onChange={handleInputChange}
          />
          <label htmlFor="understandLegal">{text?.confirmacao3}</label>
        </CheckboxItem>

        <CheckboxItem>
          <input
            required
            type="checkbox"
            id="agreeTerms"
            name="agreeTerms"
            onChange={handleInputChange}
          />
          <label htmlFor="agreeTerms">{text?.confirmacao4}</label>
        </CheckboxItem>
      </CheckboxGroup>
    </FormSection>
  );
};

export default RemoveDataForm;
